const SPINNER_ACCENT = '#116dff';

export function PreviewFrameLoader() {
  return (
    <div
      className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none"
      aria-busy="true"
      aria-live="polite"
    >
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-transparent"
        style={{ borderTopColor: SPINNER_ACCENT }}
      />
    </div>
  );
}
